<template>
  <section>
    <b-notification :closable="false">
      Loading the application
      <b-loading :is-full-page="true" v-model="isLoading" :active="true" :can-cancel="false"></b-loading>
    </b-notification>
  </section>
</template>
<script>
export default {
  name: 'Loading',
  data() {
    return {
      isLoading: true,
    };
  },
};
</script>
